export default __webpack_public_path__ + "static/media/Weight disabled.4565bb04.svg";